import React from 'react';
import styled from 'styled-components';
import Tile from './Tile';

const DiscardPile = ({ tiles, onTileClick, selectableTiles = [] }) => {
  return (
    <PileContainer>
      <PileTitle>버린 패</PileTitle>
      <TilesGrid>
        {tiles.map((tile, index) => (
          <Tile 
            key={tile.id || index}
            tile={tile}
            onClick={() => onTileClick(tile, index)}
            isSelectable={selectableTiles.includes(tile.id)}
          />
        ))}
      </TilesGrid>
    </PileContainer>
  );
};

const PileContainer = styled.div`
  width: 100%;
  padding: 10px;
  background-color: rgba(20, 61, 40, 0.8);
  border-radius: 8px;
  margin: 10px 0;
`;

const PileTitle = styled.h3`
  color: #f8cb66;
  margin: 0 0 10px 0;
  font-size: 1rem;
  text-align: center;
`;

const TilesGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 4px;
  max-height: 150px;
  overflow-y: auto;
  
  /* 스크롤바 스타일링 */
  &::-webkit-scrollbar {
    width: 4px;
  }
  
  &::-webkit-scrollbar-track {
    background: #0a2918;
    border-radius: 2px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #f8cb66;
    border-radius: 2px;
  }
`;

export default DiscardPile;
